export class OrderRequestCancellationCodeModel {
    public code: string;
    public reason: string;
    public changeRequested: boolean;
    public emailToConfirm: string;
    public dob;
    public userCancellationReason: number;

}

